module.exports = __webpack_public_path__ + "img/4_173.71bb0e15.png";